
import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import PersonsInformationGroupsListView from "./persons_information_groups-list.html";
import PersonsInformationGroupsEditView from "./persons_information_groups-edit.html";

angular.module("persons_information_groups", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('persons_information_groups', {
                url: "/persons_information_groups",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })

            .state('persons_information_groups.list', {
                url: "/list/:entity_type",
                controller: "PersonsInformationGroupsListCtrl",
                template: PersonsInformationGroupsListView,
                cache: false,
                requiredPermission: ["INFORMATION_GROUPS_READ"]
            })            
            .state('persons_information_groups.edit', {
                url: "/edit/:entity_type/:id",
                controller: "PersonsInformationGroupsEditCtrl",
                template: PersonsInformationGroupsEditView,
                cache: false,
                requiredPermission: ["INFORMATION_GROUPS_READ"]
            })
    }])
;